import { moneyFormat } from '@4beefopag/4bee-fopag-core/dist/util';
import { Skeleton } from 'antd';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import usePayrollValueBandsChart from '../usePayrollValueBandsChart';
import { sumBandsTotalValue } from '../payrollValueBands';
import LoadError from '../LoadError';

const Card = styled.div`
  height: 100%;
  padding: 16px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

const Title = styled.h3`
  margin: 0 0 8px;
  font-size: 14px;
  font-weight: 600;
`;

const Total = styled.div`
  font-size: 18px;
  font-weight: 600;
`;

export function sumPayrollValue(competencias) {
  return competencias.reduce((sum, competencia) => sum + sumBandsTotalValue(competencia.faixas), 0);
}

function PayrollValueCard({ folhaIds, competenciaInicial, competenciaFinal }) {
  const { data, isPending, isError, error, refetch } = usePayrollValueBandsChart({
    folhaIds,
    competenciaInicial,
    competenciaFinal,
  });

  const totalValue = useMemo(() => sumPayrollValue(data?.competencias ?? []), [data]);

  return (
    <Card>
      <Title>Valor da folha</Title>
      {isError ? (
        <LoadError
          error={error}
          onRetry={refetch}
        />
      ) : (
        <Skeleton
          active
          loading={isPending}
          paragraph={false}
        >
          <Total>{moneyFormat(totalValue)}</Total>
        </Skeleton>
      )}
    </Card>
  );
}

PayrollValueCard.propTypes = {
  folhaIds: PropTypes.arrayOf(PropTypes.number),
  competenciaInicial: PropTypes.string.isRequired,
  competenciaFinal: PropTypes.string.isRequired,
};

PayrollValueCard.defaultProps = {
  folhaIds: undefined,
};

export default PayrollValueCard;
